import { OrganisationResponse } from 'api/httpEntities';

export const isMultiOrg = (
  practitionerOrgs: OrganisationResponse[] = [],
): boolean => !!(practitionerOrgs?.length > 1);
